import type { NewApptState } from '../types';
import type { PayloadAction } from '@reduxjs/toolkit';

export const setCallbackUrl = (state: NewApptState, action: PayloadAction<string | null>) => {
  state.newAppt.callbackUrl = action.payload;
};
